export default "__VITE_ASSET__F6_SIjwk__"